import { IntransitUpdateComponent } from './../intransit-update.component';
import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { PageInfo } from 'src/app/core/models/page-info';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { IntransitUpdateService } from '../../../services/intransit-update.service';
import { getForwarderByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';

@Component({
  selector: 'laas-intransit-import',
  templateUrl: './intransit-import.component.html',
  styleUrls: ['./intransit-import.component.scss']
})
export class IntransitImportComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode: PermissionConstants = PermissionConstants.ViewIntransitUpdate;

  @Output() visibleChange: EventEmitter<any>;
  @ViewChild('fileUpload') fileUpload!: FileUpload;

  pageInfo: PageInfo;
  isVisible: boolean = false;
  isLoading: boolean = false;
  isSaveing: boolean = false;
  intransitRows: any[];
  intransitColumns: any[];
  forwarderOptions:any[]=[];
  facilityOptions:any[]=[];

  constructor(
    injector: Injector,
    private intransitUpdateService:IntransitUpdateService,
    private intransitUpdateComponent:IntransitUpdateComponent,
    private dropdownOptionsService: DropdownOptionsService) {
    super(injector);
    this.visibleChange = new EventEmitter<any>();
    this.intransitRows = [];
    this.intransitColumns = [
      {field:'deliveryWarehouse',header:'IntransitImport.MainTable.deliveryWarehouse', sort:true},
      {field:'forwarderName',header:'IntransitImport.MainTable.forwarderName', sort:true},
      {field:'awbNumber',header:'IntransitImport.MainTable.awbNumber', sort:true},
      {field:'shipperName',header:'IntransitImport.MainTable.shipperName', sort:true},
      {field:'shipperCity',header:'IntransitImport.MainTable.shipperCity', sort:true},
      {field:'shipperCountry',header:'IntransitImport.MainTable.shipperCountry', sort:true},
      {field:'consigneeName',header:'IntransitImport.MainTable.consigneeName', sort:true},
      {field:'consigneeCity',header:'IntransitImport.MainTable.consigneeCity', sort:true},
      {field:'consigneeCountry',header:'IntransitImport.MainTable.consigneeCountry', sort:true},
      {field:'pieces',header:'IntransitImport.MainTable.pieces', sort:true},
      {field:'actWgt',header:'IntransitImport.MainTable.actWgt', sort:true},
      {field:'bookingDate',header:'IntransitImport.MainTable.bookingDate', sort:true},
      {field:'pickUpDate',header:'IntransitImport.MainTable.pickUpDate', sort:true},
      {field:'completeDeliveryTime',header:'IntransitImport.MainTable.completeDeliveryTime', sort:true},
      {field:'brandName',header:'IntransitImport.MainTable.brandName', sort:true},
      {field:'reference',header:'IntransitImport.MainTable.reference', sort:true},
      {field:'etd',header:'IntransitImport.MainTable.etd', sort:true},
      {field:'eta',header:'IntransitImport.MainTable.eta', sort:true},
      {field:'edc',header:'IntransitImport.MainTable.edc', sort:true},
      {field:'atd',header:'IntransitImport.MainTable.atd', sort:true},
      {field:'ata',header:'IntransitImport.MainTable.ata', sort:true},
      {field:'estimatedPortClearanceTime',header:'IntransitImport.MainTable.estimatedPortClearanceTime', sort:true},
      {field:'actualPortClearanceTime',header:'IntransitImport.MainTable.actualPortClearanceTime', sort:true},
      {field:'others',header:'IntransitImport.MainTable.others', sort:true},
      {field:'mawbNumber',header:'IntransitImport.MainTable.mawbNumber', sort:true},
      {field:'route',header:'IntransitImport.MainTable.route', sort:true}
    ];

    this.pageInfo = {
      pageSize: 5,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };
    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: result => {
        this.forwarderOptions = result.map((x: any) => {
          return {
            label: `${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      },
    });

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: FacilityOptions[]) => {
        this.facilityOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  fileUploader(event: any): void {
    let files: any = event?.files;
    if (!files || files.length === 0) {
      this.toastService.warn(this.translateService.instant('IntransitImport.Message.SelectFile'));
      return;
    }

    // Reset table
    this.intransitRows.length = 0;


    // Upload file
    this.isLoading = true;
    this.intransitUpdateService.importIntransitExcel(files[0])
    .subscribe({
        next: (result) => {
          const intransits = result;
          this.intransitRows = intransits || [];
          console.log(result);
        },
        error: (err) => {
          this.isLoading = false;
          this.fileUpload.clear();
          this.toastErrorMessage(err.error);
        },
        complete: () => {
          this.isLoading = false;
          this.fileUpload.clear();
        }
      }
    );
  }

  saveBtnClick(event: any): void {

    if (!this.intransitRows || this.intransitRows.length === 0) {
      return;
    }

    const saveParameter = {
      iIntransits: this.intransitRows,
      facility: this.laasSetting.facility,
      createUser: this.userProfile.loginAccount
    };

    this.isSaveing=true;
    this.intransitUpdateService.saveIntransit(saveParameter)
      .subscribe({
        next: (result) => {
          this.dialogVisibleChange(false); // Close file upload dialog
          this.toastService.success("Saved successfully");
          //儲存後搜尋
          this.intransitUpdateComponent.searchImport(result);
        },
        error: (err) => {
          this.toastErrorMessage(err.error);
        },
        complete: () => {
          this.isSaveing=false;
        }
      });
  }

  dialogVisibleChange(value: boolean): void {
    this.visibleChange.emit(value);
  }
}
